export * from './connector';
export { ConnectProvider } from './context';
export * from './hooks';
export const getVersion = () => {
  return '1.0.0-alpha.31';
};

if (typeof window !== 'undefined') {
  (window as any).__PARTICLE_BTC_CONNECT_VERSION = getVersion();
}
